'use client'
import classNames from 'classnames'
import Img from 'src/components/shared/Img'
import { useActiveNav } from '../context/ActiveNavContext'

const SubnavDefaultSection = ({ data, isMobile, setHoverSubnav }) => {
  const { isActive } = useActiveNav()
  const isSimpleList = !(data?.children?.length > 1)
  const columns = data?.columns || 1

  const groupItems = () => {
    const groups = []
    const items = data.children || []

    for (let i = 0; i < items.length; i += columns) {
      groups.push(items.slice(i, i + columns))
    }

    return groups
  }

  const itemGroups = groupItems()

  if (isMobile) {
    return (
      <div
        data-testid="mega-menu-subnav-default-section-mobile"
        className="flex w-screen flex-col gap-4 bg-[#F5F9FF] px-10 py-6 lg:-ml-primary-xs"
      >
        {data?.children?.map((child, index) => (
          <div
            key={`${data.id}-${child.id}`}
            className={classNames(
              'flex flex-col gap-2 border-0 border-b-[0.5px] border-solid border-gray-270 pb-4',
              { 'last:border-b-0': index === data.children.length - 1 }
            )}
          >
            {!isSimpleList && (
              <p className="font-bold! text-14 text-gray-500">{child.label}</p>
            )}
            <div
              className={classNames('flex flex-col gap-4', {
                'gap-2': isSimpleList,
              })}
            >
              {child?.children?.map((subChild, subChildIndex) => (
                <a
                  href={subChild.link}
                  key={`${data.id}-${subChild.id}-${subChild.id}`}
                  aria-current={isActive(subChild) ? 'page' : undefined}
                  className={classNames('text-black-base', {
                    'border-0 border-b-[0.5px] border-solid border-gray-270 pb-2':
                      isSimpleList,
                    'border-b-0!': subChildIndex === child.children.length - 1,
                  })}
                  track={{
                    click_id: subChild.label,
                    click_text: subChild.label,
                    click_url: subChild.link,
                    nav_link_section: 'Mega Menu',
                    track_event: 'mega_menu',
                    event_action: 'link_click',
                    event_type: 'link_click',
                  }}
                >
                  <div
                    className={classNames('flex flex-row items-center gap-2')}
                  >
                    <p
                      className={classNames(
                        'text-14 font-medium text-black-base hover:underline',
                        { 'font-bold! text-blue-base': isActive(subChild) }
                      )}
                    >
                      {subChild.label}
                    </p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        ))}
      </div>
    )
  }

  return (
    <div
      data-testid="mega-menu-subnav-default-section"
      className="flex flex-col gap-2 p-8"
    >
      {itemGroups.map((group, groupIndex) => (
        <div
          key={`group-${groupIndex}`}
          className="grid gap-4"
          style={{
            gridTemplateColumns: `repeat(${columns}, 1fr)`,
          }}
        >
          {group.map((child) => (
            <div key={`${data.id}-${child.id}`} className="flex flex-col gap-2">
              {!isSimpleList && (
                <p className="font-bold! text-14 uppercase tracking-[3.5px] text-neutral-300">
                  {child.label}
                </p>
              )}
              <div
                className={classNames('flex flex-col gap-4', {
                  'gap-2': isSimpleList,
                })}
              >
                {child.children?.map((subChild) => (
                  <a
                    href={subChild.link}
                    key={`${data.id}-${subChild.id}-${subChild.id}`}
                    aria-current={isActive(subChild) ? 'page' : undefined}
                    className={'no-underline! text-black-base'}
                    onClick={() => {
                      setHoverSubnav(false)
                    }}
                  >
                    <div
                      className={classNames(
                        'flex flex-row items-center gap-6 rounded-md px-1 py-4 hover:bg-[#F5F9FF]',
                        { 'bg-blue-135': isActive(subChild) }
                      )}
                    >
                      <div>
                        <Img
                          src={subChild.icon}
                          alt={subChild.label}
                          layout="responsive"
                          width={35}
                          height={35}
                          styles={{
                            position: 'relative',
                            height: '35px',
                            width: '35px',
                          }}
                        />
                      </div>
                      <div className={classNames('flex flex-col')}>
                        <p
                          className={classNames('labelMd font-bold!', {
                            'text-blue-base': isActive(subChild),
                          })}
                        >
                          {subChild.label}
                        </p>
                        <p className="labelSm font-regular! text-gray-500">
                          {subChild.description}
                        </p>
                      </div>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}

export default SubnavDefaultSection
